module.exports = __webpack_public_path__ + "img/analytical_dashboard.dcad2031.svg";